import Swiper, { Mousewheel, Navigation } from 'swiper';

const quickAddDrawerProductGallery = () => ({
  swiper: null,
  swiperEl: null,

  init() {
    this.$nextTick(() => {
      this.initializeGallery();
    });
  },

  initializeGallery() {
    const el = this.$root.querySelector('.swiper');
    if (!el) return;

    this.swiperEl = el;
    this.swiper = new Swiper(this.swiperEl, {
      modules: [Mousewheel, Navigation],
      mousewheel: {
        forceToAxis: true,
      },
      grabCursor: true,
      preloadImages: false,
      spaceBetween: 8,
      slidesPerView: 2,
      breakpoints: {
        992: {
          slidesPerView: 1.5,
        },
      },
      navigation: {
        nextEl: this.$root.querySelector('.swiper-button-next'),
        prevEl: this.$root.querySelector('.swiper-button-prev'),
        disabledClass: 'swiper-button-hidden',
      },
    });
  },
});

export default quickAddDrawerProductGallery;